export enum PDFLibrary {
    jsPDF = "jsPDF",
    jsReport = "jsreport"
}